import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ClearIcon from "@mui/icons-material/Clear";
// import SisKonLogo from "../assets/images/webp/siskon_logo.webp";
import SisKonLogo from "../assets/images/Logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Dialog, DialogTitle, DialogContent, TextField } from "@mui/material";
import emailjs from "emailjs-com";
const navItems = [
  { label: "Home", path: "/" },
  {
    label: "About Us",
    path: "/about",
    subMenu: [
      { label: "Our Company", path: "/about/our-company" },
      { label: "Awards & Success Stories", path: "/about/awards" },
      { label: "Leadership", path: "/about/leadership" },
      { label: "Blog", path: "/about/blog" },
    ],
  },

  { label: "Products", path: "/products" },
  { label: "Parker Store", path: "/parkerStore" },
  { label: "Careers", path: "/careers" },
  { label: "Contact Us", path: "/contactUs" },
];

const HeaderComponent = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeId, setActiveId] = useState<Number | null>(0);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [closingMenu, setClosingMenu] = useState(false); // To manage smooth closing
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setActiveMenu(null); // Reset submenu state on page change
    const currentPath = location.pathname;
    const activeItem = navItems.findIndex(
      (item) =>
        item.path === currentPath ||
        (item.subMenu &&
          item.subMenu.some((subItem) => currentPath.startsWith(subItem.path)))
    );
    setActiveId(activeItem !== -1 ? activeItem : 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    formType: "Get Quote", // Add formType here
  });

  const [error, setError] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  // Validate individual fields
  const validateField = (name: string, value: string) => {
    switch (name) {
      case "name":
        return value.trim() ? "" : "Name is required";
      case "phone":
        return ""; // No validation needed for phone if email is provided
      case "email":
        return ""; // No validation needed for email if phone is provided
      case "message":
        return ""; // Message is optional, so no validation needed
      default:
        return "";
    }
  };

  // Handle field changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Validate the field on change
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  // Handle field blur (when the user leaves the field)
  const handleBlur = (name: string, value: string) => {
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  // Validate the entire form on submission
  const validateForm = () => {
    const errors = {
      name: validateField("name", formData.name),
      phone: validateField("phone", formData.phone),
      email: validateField("email", formData.email),
      message: validateField("message", formData.message),
    };

    setError(errors);

    // Ensure either phone or email is provided
    const isContactInfoProvided =
      formData.phone.trim() || formData.email.trim();

    // Return true if there are no errors and contact info is provided
    return (
      Object.values(errors).every((err) => err === "") && isContactInfoProvided
    );
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); // Start the loader
      try {
        const apiKey = process.env.REACT_APP_API_KEY_VALUE;
        const headers = {
          "x-api-key": apiKey as string,
          "Content-Type": "application/json"
        };
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/send-get-quote`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify(formData),
          }
        );

        if (response.ok) {
          alert("Email sent successfully!");
          setFormData({
            name: "",
            phone: "",
            email: "",
            message: "",
            formType: "Get Quote",
          });
          setError({
            name: "",
            phone: "",
            email: "",
            message: "",
          });
        } else {
          const errorData = await response.json();
          console.error("Error sending email:", errorData.error);
          alert("Failed to send email: " + errorData.error);
        }
      } catch (error) {
        console.error("Error submitting the form:", error);
        alert("An error occurred while sending the email.");
      } finally {
        setLoading(false); // Stop the loader
      }
    } else {
      console.log("Form validation failed:", error);
    }
    setOpen(false); // Close the dialog after submission
  };

  const PhoneClick = (phoneNumber: String) => {
    window.location.href = `tel:${phoneNumber}`;
    window.close(); // Closes the browser window if allowed
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNav = (path: string, id: Number) => {
    setActiveId(id);
    navigate(path);
    setClosingMenu(true);
  };

  const handleMenuClick = (label: string, id: Number) => {
    setActiveId(id);
    if (activeMenu === label) {
      setClosingMenu(true); // Trigger closing animation
      setTimeout(() => {
        setActiveMenu(null);
        setClosingMenu(false); // Reset closing state
      }, 300); // Match this duration with the transition duration
    } else {
      setActiveMenu(label);
      setClosingMenu(false); // Ensure closing state is reset when opening
    }
  };

  const handleSubMenuClick = (path: string) => {
    setClosingMenu(true); // Trigger closing animation
    setTimeout(() => {
      navigate(path);
      setActiveMenu(null);
      setClosingMenu(false); // Reset closing state
    }, 300); // Match this duration with the transition duration
  };

  const LearnMoreButton = styled(Button)(({ theme }) => ({
    backgroundColor: "#AB052D",
    color: "white",
    borderRadius: "50%",
    minWidth: "16px",
    height: "26px",
    padding: 0,
    marginTop: theme.spacing(1),
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: "white",
      "& .MuiSvgIcon-root": {
        color: "#AB052D",
        transform: "scale(1.2)",
        transition: "transform 0.3s",
      },
    },
  }));

  return (
    <>
      <Dialog className="scrollbar-hide" open={open} onClose={handleClose}>
        <DialogContent className="p-6 bg-white scrollbar-hide rounded-lg lg:min-w-[350px] w-[100%]">
          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block text-sm font-medium text-black">
              First & Last Name
            </label>
            <TextField
              name="name"
              variant="outlined"
              size="medium"
              fullWidth
              className="bg-white rounded-md"
              value={formData.name}
              onChange={handleChange}
              onBlur={(e) => handleBlur(e.target.name, e.target.value)}
            />
            <h2 className="text-red-400">{error?.name}</h2>

            <label className="block text-sm font-medium text-black">
              Phone Number
            </label>
            <TextField
              name="phone"
              variant="outlined"
              fullWidth
              className="bg-white rounded-md"
              value={formData.phone}
              onChange={handleChange}
              onBlur={(e) => handleBlur(e.target.name, e.target.value)}
            />
            <h2 className="text-red-400">{error?.phone}</h2>

            <label className="block text-sm font-medium text-black">
              Email
            </label>
            <TextField
              name="email"
              variant="outlined"
              fullWidth
              className="bg-white rounded-md"
              value={formData.email}
              onChange={handleChange}
              onBlur={(e) => handleBlur(e.target.name, e.target.value)}
            />
            <h2 className="text-red-400">{error?.email}</h2>

            <label className="block text-sm font-medium text-black">
              Message
            </label>
            <TextField
              name="message"
              variant="outlined"
              multiline
              rows={3}
              fullWidth
              className="bg-white rounded-md"
              value={formData.message}
              onChange={handleChange}
              onBlur={(e) => handleBlur(e.target.name, e.target.value)}
            />
            <h2 className="text-red-400">{error?.message}</h2>

            <button
              type="submit"
              className={`bg-red-600 w-full text-white py-2 rounded-md hover:bg-red-700 ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Send"}
            </button>
          </form>
        </DialogContent>
      </Dialog>
      <div className="absolute top-0 z-40 left-0 right-0">
        <header className="w-full bg-white/80 shadow-md">
          <div className="lg:px-40 px-10 py-2 flex justify-between items-center w-full">
            <img src={SisKonLogo} alt="SisKon Logo" className="h-12" />
            <div className="hidden md:flex items-center space-x-12">
              <button
                onClick={() => PhoneClick("+91 9898507238")}
                className="text-blue-900 font-medium hover:underline"
              >
                +91 9898507238
              </button>
              <button
                onClick={handleClickOpen}
                className="px-10 py-2 border border-blue-900 text-blue-900 rounded-full text-sm"
              >
                Get A Quote
              </button>
            </div>
            <button
              className="md:hidden text-black"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </button>
          </div>
        </header>

        <nav className="bg-black/50 hidden md:block lg:block py-3 absolute w-full z-20">
          <div className="px-40 py-2 flex relative justify-around space-x-10">
            {navItems.map((item, index) => {
              // const isActive = location.pathname == item.path;
              const isActive = activeId === index;

              return (
                <div
                  key={index}
                  className={`border-t w-full top-1 right-10 left-10 ${
                    isActive ? " border-gray-100 " : " border-gray-600"
                  } `}
                >
                  <button
                    className={`text-white  pt-2 text-base font-light opacity-80 hover:opacity-100 ${
                      isActive ? "opacity-100 font-semibold" : ""
                    }`}
                    onClick={() =>
                      item.subMenu && item.subMenu.length > 0
                        ? handleMenuClick(item.label, index)
                        : handleNav(item.path, index)
                    }
                  >
                    {item.label}
                  </button>

                  {item.subMenu &&
                    item.subMenu.length > 0 &&
                    activeMenu === item.label && (
                      <div
                        className={`absolute top-full min-h-[110px] w-[70%] mt-2 bg-white flex border border-gray-100 transform transition-all duration-300 ${
                          closingMenu
                            ? "-translate-y-5 opacity-0"
                            : "translate-y-0 opacity-100"
                        }`}
                        style={{
                          clipPath:
                            "polygon(0 0, 34px 12px, 100% 10px, 100% 100%, 0 100%)",
                          willChange: "clip-path",
                          WebkitClipPath:
                            "polygon(0 0, 34px 12px, 100% 10px, 100% 100%, 0 100%)",
                        }}
                      >
                        {item.subMenu?.map((subItem, subIndex) => (
                          <div
                            key={subIndex}
                            className="w-64 flex-1 p-4 border-r last:border-r-1 border-gray-300 flex flex-col items-start gap-3 cursor-pointer"
                            onClick={() => handleSubMenuClick(subItem.path)}
                          >
                            <LearnMoreButton
                              aria-label="Learn More"
                              sx={{
                                minWidth: {
                                  xs: 24,
                                  sm: 28,
                                  md: 32,
                                  lg: 32,
                                  xl: 32,
                                },
                                minHeight: {
                                  xs: 24,
                                  sm: 28,
                                  md: 32,
                                  lg: 32,
                                  xl: 32,
                                },
                              }}
                              className="mb-1"
                            >
                              <ChevronRightIcon />
                            </LearnMoreButton>
                            <button className="text-black text-l text-left pointer-events-none whitespace-nowrap overflow-hidden text-ellipsis">
                              {subItem.label}
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </nav>

        {/* Mobile Drawer */}
        <AnimatePresence>
          {drawerOpen && (
            <motion.div
              className="fixed h-full lg:hidden top-0 inset-0 z-50 overflow-hidden"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="absolute inset-0 bg-white" />
              <motion.div
                className="absolute top-0 bottom-0 right-0 w-4 h-4 bg-[#3a4855] rounded-full origin-top-right"
                initial={{ scale: 0, borderRadius: "100%" }}
                animate={{ scale: 50, borderRadius: "0" }}
                exit={{ scale: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{
                  delay: 0.4,
                  duration: 2,
                  ease: [0.22, 1, 0.36, 1],
                }}
              />
              <motion.div
                className="relative w-full p-8 z-10 h-full overflow-y-auto flex flex-col justify-between scrollbar-hidden  text-white"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ delay: 0.5, duration: 0.3 }}
              >
                <div className="flex flex-col justify-around h-screen">
                  <div>
                    <button
                      className="absolute top-5 bg-white/10 p-2 rounded-full right-5 z-20 text-gray-600 hover:text-gray-800"
                      onClick={() => setDrawerOpen(false)}
                    >
                      <ClearIcon sx={{ color: "white" }} fontSize="medium" />
                    </button>

                    <img
                      src={SisKonLogo}
                      alt="SisKon Logo"
                      className="w-28 h-auto "
                    />

                    <div className="flex flex-col w-full justify-start gap-5 mt-10">
                      {navItems.map((item, index) => (
                        <div key={index}>
                          <button
                            className="text-lg relative font-normal px-5 w-full text-start border-b border-gray-300/30 pb-2"
                            onClick={() => {
                              if (item.label !== "About Us" && item.path) {
                                navigate(item.path);
                                setDrawerOpen(false);
                              } else {
                                setAboutOpen(!aboutOpen);
                              }
                            }}
                          >
                            {item.label}

                            {item.label === "About Us" &&
                              (aboutOpen ? (
                                <KeyboardArrowUpIcon className="absolute right-4 top-0" />
                              ) : (
                                <KeyboardArrowDownIcon className="absolute right-4 top-0" />
                              ))}
                          </button>

                          {item.label === "About Us" && aboutOpen && (
                            <AnimatePresence>
                              <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                viewport={{ once: true, amount: 0.5 }}
                                transition={{ duration: 0.3 }}
                                className="overflow-hidden text-start flex flex-col"
                              >
                                {item.subMenu?.map((subItem, subIndex) => (
                                  <button
                                    key={subIndex}
                                    className="border-b  text-start border-gray-300/30 py-3 pl-5 text-sm"
                                    onClick={() => {
                                      navigate(subItem.path);
                                      setDrawerOpen(false);
                                    }}
                                  >
                                    {subItem.label}
                                  </button>
                                ))}
                              </motion.div>
                            </AnimatePresence>
                          )}
                        </div>
                      ))}

                      {/*  <button className="text-lg text-start px-5 font-normal border-b border-gray-300/30 pb-2">
                    Services
                  </button>
                  <button className="text-lg text-start px-5 font-normal border-b border-gray-300/30 pb-2">
                    Careers
                  </button>
                  <button className="text-lg text-start px-5 font-normal border-b border-gray-300/30 pb-2">
                    Contact Us
                  </button>*/}
                    </div>
                  </div>
                  <div className="mt-10 flex justify-start flex-col font-normal bottom-10 right-0 left-7 p-2 gap-2">
                    <button
                      onClick={() => PhoneClick("+919898507238")}
                      className="text-white text-start hover:underline"
                    >
                      +91 9898507238
                    </button>
                    <button
                      onClick={handleClickOpen}
                      className="px-7 py-2 w-10/12 md:w-1/2 rounded-full border-2 border-white text-white transition-colors"
                    >
                      Get a Quote
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default HeaderComponent;
